import { CollectionCard } from '@/components/ui/cards';
import useCategoryStore from '@/store/category.store';
import { findObjectById } from '@/utils/global';
import { useMemo } from 'react';

export const ProductCollections = ({ ids }) => {
  const { categoryTreeData } = useCategoryStore((state) => state);
  const categories = useMemo(() => {
    return ids
      .map((id) => {
        const info = findObjectById(categoryTreeData?.children_data, 'id', id);
        if (info?.pdp_image && info?.pdp_title && info?.pdp_label) {
          return {
            label: info?.pdp_label,
            image: info?.pdp_image,
            title: info?.pdp_title,
            href: info?.url_key,
          };
        }
        return null;
      })
      .filter((info) => !!info);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids]);
  return categories?.length > 0 ? (
    <section className='my-6 max-md:my-3.5'>
      <div className='grid gap-5 lg:grid-cols-4'>
        {categories.slice(0, 3)?.map((banner, i) => (
          <CollectionCard
            banner={banner}
            key={banner.href}
            cols={i !== 2 ? '' : 'col-span-2'}
          />
        ))}
      </div>
    </section>
  ) : null;
};

export default ProductCollections;
